export const DashboardLoading = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-6 p-8">
      <div className="relative">
        {/* Outer ring */}
        <div className="w-16 h-16 border-4 border-purple-600/20 rounded-full"></div>
        {/* Inner spinning ring */}
        <div className="absolute inset-0 w-16 h-16 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="space-y-2 text-center">
        <h3 className="text-lg font-medium text-white">Loading Dashboard</h3>
        <p className="text-sm text-gray-400">Please wait while we set up your workspace...</p>
      </div>
    </div>
  </div>
)
